export const SET_LISTING_SECTIONS = 'lv3/SET_LISTING_SECTIONS';
export const SET_LISTING_SECTIONS_IS_LOADING = 'lv3/SET_LISTING_SECTIONS_IS_LOADING';
export const SET_SECTIONS_LOADING = 'lv3/SET_SECTIONS_LOADING';
